import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-navigate-sharp",
  "use": "icon-navigate-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-navigate-sharp\"><title>Navigate</title><path d=\"M480 32L32 240h240v240L480 32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol